// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"style_fieldset__3_tSQ","campos":"style_campos__3xMIv","tag":"style_tag__20BoD","fade":"style_fade__1MlSC","remove":"style_remove__61Pp5"};